import React, { useEffect, useState } from 'react'
import { Grid, Button, Dropdown, DropdownButton, DropdownMenu, DropdownItem } from "@deere/fuel-react"
import { useSelector } from 'react-redux';
import { useOktaAuth } from '@okta/okta-react'
import { getSuppSurveyConfiguration } from '../services/userService';
import { useTranslation } from "react-i18next";
import i18next from 'i18next'
import cookie from 'js-cookie'
import { handleSaveOrUpdate, saveUserAnswers,uploadSurveyFile } from '../utils/saveSurveyUtils'
import { savedSuccessFullySurvey } from '../redux/action/saveAction'
import { useDispatch } from 'react-redux'
import {useUserInfo} from '../providers/userProvider'
import { LHR, SCBM_CODE, SCBM_INDIRECT, COC, CLASSNAME_FILEINPUT } from '../utils/surveyLiterals'
import store from '../redux/store'
import { updateGenResponse } from '../redux/action/genericSurveyAction'
import 'flag-icon-css/css/flag-icons.min.css'
import {setFieldsWithErrors} from "../redux/action/validationAction";
import { ModalDocument } from './modals/ModalDocument';
import { getHelpDocPdfBySurveyId } from '../services/surveyHelpDoc.service';
import { CRS_EXT_TOKEN } from '../utils/constants';

function getAnswers(survey,store) {
    let answers = store.getState().genericSurvey.surveyAnswersForm[survey.code];
    if(!answers){
        answers = store.getState().survey.surveyAnswers;
    }
    return answers;
}

function getSurveyResponse(survey,store) {
    let surveyResponse = store.getState().genericSurvey.surveyResponses[survey.code];
    if(!surveyResponse){
        surveyResponse = store.getState().survey.surveyResponse;
    }
    return surveyResponse;
}

const ButtonsSection = React.forwardRef(({ campaign, setSurvey, clearFunction, survey, surveyLanguages, url, setUrl, uploadedFiles}) => {
    const { authState } = useOktaAuth();
    const campaignAssigned = useSelector(state => state.campaign.campaignAssigned)
    const userInfo = useUserInfo();
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const [displayButton, setDisplayButton] = useState(false)
    const [currentLanguageCode, setCurrentLanguageCode] = useState(cookie.get('i18next') || 'en');
    const [showModal, setShowModal] = useState(false);

    let isAuthMethodOkta = authState && authState.isAuthenticated ? true : false;
    let token = isAuthMethodOkta ? authState.accessToken.accessToken : sessionStorage.getItem(CRS_EXT_TOKEN);

    const getI18nLanguageCode = (locale) => {
      if (!locale || typeof locale !== 'string') {
        return 'en';
      }
      return locale.split(/[-_]/)[0].toLowerCase();
    }

    // Store full locale for API calls, only pass base language to i18next for resource loading
    const changeLanguage = locale => {
        // Persist the full locale (e.g., pt_BR) for API query params and page reload
        setCurrentLanguageCode(locale);
        cookie.set('i18next', locale, { expires: 365 });
        // Only pass base language to i18next (e.g., pt) for resource loading
        i18next.changeLanguage(getI18nLanguageCode(locale));
    }

    const handleSave = (e) => {
        e.preventDefault();
        clearFunction();
        dispatch(setFieldsWithErrors(new Map()))
        let answers = getAnswers(survey,store);
        let surveyResponse = getSurveyResponse(survey,store);
        if(survey.code === SCBM_CODE || survey.code === SCBM_INDIRECT){
            handleSaveOrUpdate(surveyResponse, answers, campaign, userInfo, authState, dispatch, t('lbl_success_save_message'),survey);
        }
        else{
            saveUserAnswers(surveyResponse, answers, campaign, userInfo, isAuthMethodOkta, token).then(response => {
                if(response.variant && response.variant === 'success'){                 
                    uploadedFiles.forEach((file) => {
                      const fd = new FormData();
                      fd.append('file', file.fileData);
                      fd.append('content-type','application/pdf');
                      uploadSurveyFile(fd, campaign, file.fileNumber, userInfo, token).then(response => { 
                      }).catch(error => {
                        console.log(error);
                      });
                    })
                    dispatch(updateGenResponse({surveyCode: survey.code, surveyResponse: response.updatedResponse}));
                    response.description = t('lbl_success_save_message');
                }
                dispatch(savedSuccessFullySurvey(response));
            }).catch(error => {
                console.log(error);
            });
           
        }
        window.scrollTo(0, 0);
    }


    useEffect(() => {
        getSuppSurveyConfiguration(campaignAssigned.surveyId, currentLanguageCode, token, isAuthMethodOkta)
            .then((s) => {
                setSurvey(s);
                s.code === SCBM_CODE || s.code === SCBM_INDIRECT || s.code === LHR || s.code === COC ? setDisplayButton(true) : setDisplayButton(false);
            })
            if (setUrl) {
                getHelpDocPdfBySurveyId(token, campaignAssigned.surveyId, currentLanguageCode, isAuthMethodOkta).then(async (response) => {
                    if (response.status === 200) {
                      const blob = await response.blob();
                      const url = window.URL.createObjectURL(blob);
                      setUrl({ show: true, url: url });
                    } else {
                      setUrl({ show: false, url: null });
                    }
                  })
                  .catch((err) => {
                     console.log(err);
                     setUrl({ show: false, url: null });
                  });
            }
    }, [currentLanguageCode])

    
    return (
      <>
        <Grid container className="card position-sticky fixed-bottom">
        {url && url.show && (
          <Grid item className="card-body p-3 text-left">
            <Button variant="secondary" type="button" onClick={() => setShowModal(true)}>
              {t("lbl_Help_Doc")}
            </Button>
          </Grid>
        )}
          <Grid item className="card-body p-3 text-right" justifyContent="space-between">
            {surveyLanguages && surveyLanguages.length > 1 && (
              <Dropdown size="small">
                <DropdownButton onClick={(e) => e.preventDefault()}>{t("btn_change_language")} </DropdownButton>
                <DropdownMenu placement="top-start">
                  {surveyLanguages.map(({ code, name, country_code }) =>
                    currentLanguageCode === code ? (
                      <DropdownItem key={country_code} href="#" className="nav-link active" onClick={(e) => e.preventDefault()}>
                        <span className={`flag-icon flag-icon-${country_code} mx-2`} style={{ opacity: 0.3 }}></span>
                        {name}
                      </DropdownItem>
                    ) : (
                      <DropdownItem key={country_code} href="#" onClick={() => changeLanguage(code)}>
                        <span className={`flag-icon flag-icon-${country_code} mx-2`} style={{ opacity: 1 }}></span>
                        {name}
                      </DropdownItem>
                    )
                  )}
                </DropdownMenu>
              </Dropdown>
            )}
            <Button className="mr-2 ml-2" variant="secondary" type="button" onClick={handleSave}>
              {t("btn_save_survey")}
            </Button>
            <Button className="mr-2" variant="primary" type="submit">
              {t("btn_review")}
            </Button>
          </Grid>
        </Grid>
        <ModalDocument 
          showModal={showModal}
          setShowModal={setShowModal}
          labelBtnPrimary={t("btn_close")}
          titleModal={t("lbl_Help_Doc")}
          iFrameUrl={url && url.url}
        />
      </>
    )
})

export default ButtonsSection
